export default __webpack_public_path__ + "static/media/test_image_3.38dcb127.png";